import { call, put, select, take } from 'typed-redux-saga/macro';

import { getRoute } from 'Config';
import type { GetActionByType } from 'Lib/reduxType';

import { logout } from 'Store/commonActions';
import { removeEmail } from 'Store/email/actions';
import { REMOVE_EMAIL_ERROR, REMOVE_EMAIL_SUCCESS } from 'Store/email/constants';
import { verifyRouteSuccess } from 'Store/loading/actions';
import { navigate } from 'Store/routing/actions';
import { getIsUserLoggedIn } from 'Store/user/selectors';

import { VERIFY_EMAIL_REMOVAL_DEEPLINK_ROUTE } from '../constants';

export function* verifyEmailRemovalDeeplinkRouteSaga(
  action: GetActionByType<typeof VERIFY_EMAIL_REMOVAL_DEEPLINK_ROUTE>
) {
  yield* call(removeEmailDeeplink, action);
  yield* put(verifyRouteSuccess());
}

export function* removeEmailDeeplink(
  action: GetActionByType<typeof VERIFY_EMAIL_REMOVAL_DEEPLINK_ROUTE>
) {
  const token = action.payload.otp;
  yield* put(removeEmail(token));
  yield* take([REMOVE_EMAIL_SUCCESS, REMOVE_EMAIL_ERROR]);
  const isLoggedIn = yield* select(getIsUserLoggedIn);
  if (isLoggedIn) {
    yield* put(logout());
  }
  yield* put(navigate(getRoute('emailRemove'), { replace: true }));
}
